module.exports = __webpack_public_path__ + "media/img/api-e44d0d996a5a4c562d811f6587ff55a2.jpg";